export default [
	{
		path: '/projects/:slug',
		lazy: async () => {
			const Module = await import('../../pages/project/ProjectPage');
			return { Component: Module.default };
		},
	},
];
